import { lazy } from 'react';
import { useRoutes, Navigate } from 'react-router-dom';

// 登录
import {Login} from '../views/Login'

// 路由保护组件
import {ProtectedRoute} from '../components/ProtectedRoute'

// 政策库首页
import {Policy} from '../views/Policy'

// 政策库搜索页
import {PolicySearchPage} from '../views/Policy/policySearchPage'

// 政策库专题页
import {PolicySubjectPage} from '../views/Policy/policySubjectPage'

// 政策库文件页
import {PolicyFilePage} from '../views/Policy/policyFilePage'

// 政策库对比页
import {PolicyComparePage} from '../views/Policy/policyComparePage'

// 政策库对比选择页
import {PolicyCompareSelectPage} from '../views/Policy/policyCompareSelectPage'

// 海外智库
import {ThinkTankAbroad} from '../views/ThinkTankAbroad'

// 收藏夹
import {Collections} from '../views/Collections'

// 文章分享
import {Share} from '../views/Share'

export const routeItems = [
  {
    path:'login',
    element:<Login/>
  },
  {
    path:'policy',
    children:[
      {
        path:'',
        element: <Policy/>,
      },
      {
        path:'search',
        element:<ProtectedRoute><PolicySearchPage/></ProtectedRoute>
      },
      {
        path:'subject',
        element:<ProtectedRoute><PolicySubjectPage/></ProtectedRoute>
      },
      {
        path:'share',
        element:<ProtectedRoute><Share/></ProtectedRoute>
      },
      {
        path:'file',
        element:<ProtectedRoute><PolicyFilePage/></ProtectedRoute>
      },
      {
        path:'compare',
        element:<ProtectedRoute><PolicyComparePage/></ProtectedRoute>
      },
      {
        path:'compareSelect',
        element:<ProtectedRoute><PolicyCompareSelectPage/></ProtectedRoute>
      }
    ]
  },
  {
    path:'think-tank-abroad',
    element:<ProtectedRoute><ThinkTankAbroad/></ProtectedRoute>
  },
  {
    path:'collections',
    element:<ProtectedRoute><Collections/></ProtectedRoute>
  },
  // ✅ 修改：使用index路由而不是Navigate
  {
    path: '/',
    element: <Policy/>, // 直接渲染Policy组件，不使用重定向
  },
  // ✅ 移除通配符重定向，避免循环
  // {
  //   path: '*',
  //   element: <Navigate to="/policy" replace />,
  // },
];

const Routes = () => {
  return useRoutes(routeItems);
};

export default Routes;
